module.exports = __webpack_public_path__ + "static/media/colheitadeira.131217a5.svg";